"use client";

import { Splash } from "@/components/Splash/Splash";
import { ApiErrorMessage } from "@cloudspire/shared/components/ApiErrorMessage/ApiErrorMessage";
import { parseDetailErrorV2 } from "@cloudspire/shared/helpers/api/parseDetailErrorV2";
import { useMemo } from "react";
import { useIntl } from "react-intl";

/** @type {import("@cloudspire/shared/components/DataHandler/DataHandler").DataHandlerErrorComponent} */
export const SplashErrorSearch = ({ error, status }) => {
  const intl = useIntl();

  const apiErrorDetail = useMemo(() => {
    return parseDetailErrorV2({ parsedJson: error });
  }, [error]);

  if (status === 401) {
    return (
      <Splash
        splashName="error"
        title={intl.formatMessage({ defaultMessage: "Autorisation requise" })}
        description={
          apiErrorDetail ??
          intl.formatMessage({
            defaultMessage:
              "Vous ne disposez pas des autorisations nécessaires.",
          })
        }
      />
    );
  }

  if (status === 422) {
    return (
      <Splash
        splashName="error"
        title={
          apiErrorDetail ??
          intl.formatMessage({
            defaultMessage:
              "Les critères de recherche ne vous permettent pas d’effectuer cette action.",
          })
        }
      >
        <ApiErrorMessage withCaughtErrors={true} />
      </Splash>
    );
  }

  return (
    <Splash
      splashName="error"
      title={intl.formatMessage({ defaultMessage: "Une erreur" })}
      description={
        apiErrorDetail ??
        intl.formatMessage({
          defaultMessage: "Une erreur est survenue.",
        })
      }
    />
  );
};
